import { registerDecorator, ValidationArguments, ValidationOptions } from 'class-validator';

function isValid(n: string) {
    let firstChar;
    let number;
    const pattern = /^([0]{1})([7-9]{1})([0|1]{1})([\d]{1})([\d]{7})$/g;

    if (!n || n.length < 5) return false;

    firstChar = n.substring(0, 1);
    number = firstChar === '0' ? n : '0' + n;
    return pattern.test(number.replace(/\s+/g, ''));
}

export function IsMobileNumber(validationOptions?: ValidationOptions) {
    return function (object: Object, propertyName: string) {
        registerDecorator({
            name: 'isMobileNumber',
            target: object.constructor,
            propertyName,
            options: validationOptions,
            constraints: [],
            validator: {
                validate(value: string, args: ValidationArguments) {
                    return isValid(value);
                },
            },
        });
    };
}
